import { useFlag } from '@automata/utils/hooks';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { Icon } from '../customIcons/misc';

const EmptyPreviewDisplay = () => {
  const isPlanningOptionsEnabled = useFlag('fe.planning_options');

  if (isPlanningOptionsEnabled)
    return (
      <Stack
        spacing={3}
        justifyContent="center"
        alignItems="center"
        height="100%"
        textAlign="center"
      >
        <Icon
          iconType="rocketIcon"
          sx={{ fontSize: 64, color: 'transparent' }}
        />

        <Typography variant="body1">
          You&apos;re all set to preview your workflow!
        </Typography>

        <Stack spacing={1.5} color="text.secondary">
          <Typography
            variant="subtitle1"
            sx={{
              textTransform: 'uppercase',
              letterSpacing: 1,
              fontWeight: 500,
            }}
          >
            Next steps:
          </Typography>

          <Typography variant="body1">
            1. Choose the number of batches to plan
          </Typography>
          <Typography variant="body1">
            2. Set your planning configuration and parameters
          </Typography>
          <Typography variant="body1">
            3. Press the <b>Plan and Preview</b> button to create your plan!
          </Typography>
        </Stack>
      </Stack>
    );

  return (
    <Stack justifyContent="center" alignItems="center" height="100%" p={3}>
      <Stack direction="row" alignItems="center" gap={3}>
        <Typography fontSize={100}>🚀</Typography>
        <Box maxWidth="31em">
          <Typography variant="h4" component="h2" mb={1}>
            Nothing here yet!
          </Typography>

          <Typography variant="subtitle2" component="h3">
            {
              'You\'re all set! Everything looks good. Press the "Create Plan" button to create your first plan.'
            }
          </Typography>
        </Box>
      </Stack>
    </Stack>
  );
};

export default EmptyPreviewDisplay;
